module.exports = __webpack_public_path__ + "img/_1.3b7c0c59.webp";